import React from 'react';
import { Link } from '@reach/router';
import './Styles/NavBar.css';

/**
 * Component that renders a responsive menubar.
 * Expects two props:
 * - pages: an array of page objects.
 * a page object contains {name, label, path, color}
 * - active: a page name that is currently active.
 * this link will be colored in the page's color and ignore clicks
 */
export class NavBar extends React.Component {
  render() {
    return (
      <nav className="NavBar">
        <span className="NavBar__logo" />
        <span className="NavBar__toggle">
          <i className="fas fa-bars" onClick={this.clickedToggle} />
        </span>
        <ul className="MainNav" id="menu">
          {this.props.pages.map(this.renderPageLink)}
        </ul>
      </nav>
    );
  }

  renderPageLink = page => {
    const active = this.props.active === page.name;
    return (
      <li key={page.name} className="NavItem">
        <Link
          to={page.path}
          className={'NavLink ' + (active ? 'active' : '')}
          style={active ? { color: page.color } : {}}
        >
          {page.label}
        </Link>
      </li>
    );
  };

  clickedToggle = () => {
    let menu = document.getElementById('menu');
    menu.classList.toggle('MainNav--active');
  };
}
